// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"5862":"142cd48ca8ec32e57725","7471":"6423b9b898ffefeb7d1d"}[chunkId] + "";
};